/*
 * Copyright (c) 2022 Robert J Whelton. All rights reserved.
 */
import * as React from "react"
import CssBaseline from "@mui/material/CssBaseline"
import {ThemeProvider} from "@mui/material/styles"

import Layout from "./Layout"
import globalTheme from "../theme"
import {navigate} from "gatsby"
import {isLoggedIn} from "../services/auth"

const LayoutComponent = ({children, path}) => {
  const authRequired = path && path.startsWith('/private/') && !isLoggedIn()
  if (authRequired) {
    navigate("/login", {state: {redirect: path}, replace: true})
  }

  return (
    <>
      <CssBaseline/>
      <ThemeProvider theme={globalTheme}>
        <Layout>{authRequired ? null : children}</Layout>
      </ThemeProvider>
    </>
  )
}

export default LayoutComponent
